import { Button } from "@mantine/core";
import type { ReactNode } from "react";
import { ErrorState, LoadingState, PermissionDenied } from "@how/ui";
import { supabase } from "../../lib/supabase";
import { usePlatformRole } from "./platform-role";

export { RequireSession } from "@how/app-kit";

/** The control plane is for DCX staff only: an active platform membership is required to see anything. */
export function RequirePlatformRole({ children }: { children: ReactNode }) {
  const role = usePlatformRole();
  if (role.isPending) return <LoadingState label="Checking your access" />;
  if (role.isError) {
    return (
      <ErrorState
        message="We could not check your access."
        onRetry={() => {
          void role.refetch();
        }}
      />
    );
  }
  if (role.data === null) {
    return (
      <PermissionDenied
        title="This console is for DCX Logic staff"
        message="Your account is signed in but has no platform role. Church staff and members use their church's dashboard or portal."
        action={
          <Button
            variant="light"
            onClick={() => {
              void supabase.auth.signOut();
            }}
          >
            Sign out
          </Button>
        }
      />
    );
  }
  return <>{children}</>;
}
